import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import user from './store/modules/user';
import auth from './store/modules/auth';
import route from './store/modules/route';
import product from './store/modules/product';
import appInfo from './store/modules/appInfo';
import purcharseOrder from './store/modules/purcharseOrder';
import { loader } from './utils/loader.js';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    user,
    auth,
    route,
    product,
    appInfo,
    purcharseOrder,
    loader
  },
  strict: debug,
  plugins: [createPersistedState()],
});
